module.exports = __webpack_public_path__ + "media/images/black_history_month/recipes-dish-19b401f36175fea258d196f5ac599c5e.png";